// Phase-0 sandbox banner.
//
// Rendered at the top of the document flow (NOT a floating overlay) when the
// app was built with MASHFA_DEMO_MODE=true. The constant `__MASHFA_DEMO_MODE__`
// is injected by Vite's `define` plugin, so production builds without the env
// var get the banner branch dead-code-eliminated entirely.
//
// Side effect: while the banner is mounted, --mashfa-banner-h is set on the
// document root so AppShell can shrink its 100vh container to "100vh - banner"
// and avoid an extra body scrollbar.

import { useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'

const BANNER_HEIGHT_PX = 36

const BANNER_TEXT: Record<string, { text: string; dir: 'ltr' | 'rtl' }> = {
  ar: { text: 'بيئة تجريبية — لا تستخدم بيانات مرضى حقيقيين', dir: 'rtl' },
  ku: { text: 'ژینگەی تاقیکردنەوە — داتای نەخۆشی ڕاستەقینە بەکارمەهێنە', dir: 'rtl' },
  de: { text: 'Demo-Umgebung — keine echten Patientendaten eingeben', dir: 'ltr' },
  en: { text: 'Demo environment — do not enter real patient data', dir: 'ltr' },
}

export function DemoBanner() {
  if (!__MASHFA_DEMO_MODE__) return null
  return <DemoBannerInner />
}

function DemoBannerInner() {
  const { i18n } = useTranslation()
  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      '--mashfa-banner-h',
      `${BANNER_HEIGHT_PX}px`,
    )
    return () => {
      document.documentElement.style.removeProperty('--mashfa-banner-h')
    }
  }, [])

  const lang = (i18n.language || 'ar').slice(0, 2)
  const entry = BANNER_TEXT[lang] ?? BANNER_TEXT.ar

  return (
    <div
      role="status"
      aria-label="Demo environment notice"
      data-print-hide=""
      style={{
        backgroundColor: '#FCE96A',
        color: '#1f2937',
        height: BANNER_HEIGHT_PX,
        padding: '0 16px',
        fontSize: 13,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: '1px solid #d4ad00',
        lineHeight: 1.2,
      }}
    >
      <span dir={entry.dir}>{entry.text}</span>
    </div>
  )
}
